<template>
  <div class="guarantor-accepted">
    <div class="accept-title">
      <div class="check-icon">
        <CheckIcon size="16" color="#FFFFFF" />
      </div>
      <h1 class="h1">Tudo certo!</h1>
    </div>

    <p class="first-message">
      Vamos avisar <b>{{ name | capitalizeInSpaces }}</b> que você aceitou ser avalista do pedido:
    </p>

    <p class="order-id">
      {{ orderId }}
    </p>

    <p class="second-message">
      Assim que a compra for confirmada, você receberá uma notificação.
      Fique de olho em seu email e SMS.
    </p>

    <div class="footer">
      <p class="small-regular">
        Caso tenha alguma dúvida, acesse o nosso <a href="https://www.parcelex.com.br/duvidas" target="_blank">FAQ</a>
        ou envie um email para
        <a href="mailto:atendimento@parcelex.com.br">atendimento@parcelex.com.br</a>
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { CheckIcon } from '@vue-hero-icons/outline';
import StringMixin from '@/mixins/string';

export default {
  name: 'guarantor-accepted',
  mixins: [StringMixin],
  data: () => ({}),
  components: {
    CheckIcon,
  },
  computed: {
    ...mapState('guarantor', [
      'guarantorData',
    ]),
    name() {
      return this.guarantorData.name;
    },
    orderId() {
      return this.guarantorData.transaction.orderId;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../styles/index.scss';

  .guarantor-accepted {
    margin-top: 24px;

    @media (min-width: $breakpoint-large) {
      margin-top: 27px;
      padding: 0 40px;
    }
  }

  .accept-title {
    display: flex;
    gap: 12px;

    align-items: center;

    @media (min-width: $breakpoint-large) {
      justify-content: center;
    }
  }

  .check-icon {
    display: flex;
    justify-content: center;
    align-items: center;

    background-color: var(--green-500);

    width: 24px;
    height: 24px;

    border-radius: 50%;
  }

  .first-message {
    @extend .body-regular;

    margin-top: 16px;

    @media (min-width: $breakpoint-large) {
      margin-top: 24px;
      text-align: center;
    }
  }

  .order-id {
    @extend .body-semi-bold;
    @extend .gray-900;

    width: fit-content;

    margin-top: 24px;
    padding: 4px 12px;

    background-color: #F1F5F9;

    border-radius: 6px;

    @media (min-width: $breakpoint-large) {
      margin: 24px auto 0 auto;
    }
  }

  .second-message {
    @extend .body-regular;
    @extend .gray-900;

    margin-top: 24px;

    @media (min-width: $breakpoint-large) {
      text-align: center;
    }
  }

  .footer {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 20px 24px;

    background-color: #F8FAFC;

    p {
      color: #64748B;
    }

    @media (min-width: $breakpoint-large) {
      position: static;

      padding: 0;
      margin-top: 36px;

      text-align: center;

      background-color: var(--white);
    }
  }
</style>
